import React, { Component } from "react";
import ComingSoon from "../pages/coming/coming";
//import Splash from "../pages/splash/Splash";

export default class Main extends Component {
  render() {
    return (
      <div>
         <ComingSoon
          title="منصة الميدان الرقمي"
          subtitle="انتظرونا ... سنجعل التعليم ممتعاً أكثر"
          bgColor="#394E51"
          textColor="#eeeeee"
          date="Wed Nov 01 2023 00:00:00 GMT+0300 (GMT+03:00)"
          illustration="development"
        /> 
      </div>
    );
  }
}
